import React, { Component } from 'react';
import { message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';

class RevenueVisit extends Component {

    state = {
        loading: false,
        pagination: {
            pageSize:10,
            current:1,
        },
        searchParams: {},
        data: [],
    }

    filterDataWithoutObject = (params) => {
        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            if (typeof value !== 'object') {
                obj[key] = value;
            }
        }
        return obj;
    }

    loadData = () =>{
        this.setState({ loading: true });
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        
        const params = this.filterDataWithoutObject(searchParams);
        
        const options = {
            method: 'POST',
            url: API_URL.home.queryIncomeVisitReportList,
            data: {
                offset: current,
                limit: pageSize,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination,searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {searchParams,...params},
        }, () => {
            this.loadData();
        });
    }



    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.home.exportIncomeVisitReport;
        //ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
        this.addToDownloadSite({ ...sortParams, ...searchParams }, url, 'INCOME_VISIT');
    }

    
    // addToDownloadSite = (searchArray, url, type) => {
    //     const options = {
    //         method: 'POST',
    //         url: API_URL.common.startAsynchronousExport,
    //         data: { type },
    //         dataType: 'json',
    //         doneResult: (res) => {
    //             const { success, asynchronousExportId } = res;
    //             message.success(success);
    //             const params = { ...searchArray, asynchronousExportId }
    //             ExportUtil.export(params, null, url);
    //         },
    //     };
    //     $.sendRequest(options);
    // }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { asynchronousExportId } = res;
                const params = { ...searchArray, asynchronousExportId }
                const options = {
                    method: 'POST',
                    url,
                    data: params,
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                    },
                };
                $.sendRequest(options);
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: 'JDE主项目号',
        dataIndex: 'jdeMainCode',
        key: 'jdeMainCode',
        fixed: 'left',
        width: 100,
    }, {
        title: 'JDE项目号',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
        fixed: 'left',
        width: 100,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessName',
        key: 'lineOfBusinessName',
        width: 100,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 100,
    }, {
        title: '项目分类',
        dataIndex: 'investigationTypeName',
        key: 'investigationTypeName',
        width: 150,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 80,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 180,
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 100,
    }, {
        title: '期间',
        dataIndex: 'month',
        key: 'month',
        width: 100,
    }, {
        title: '项目季度',
        dataIndex: 'quarter',
        key: 'quarter',
        width: 80,
    }, {
        title: '执行二级业务线分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 120,
    }, {
        title: '项目阶段',
        dataIndex: 'investigationStageNames',
        key: 'investigationStageNames',
        width: 80,
    }, {
        title: '项目分期',
        dataIndex: 'investigationByStageNames',
        key: 'investigationByStageNames',
        width: 100,
    }, {
        title: 'PM工号',
        dataIndex: 'pmCode',
        key: 'pmCode',
        width: 100,
    }, {
        title: 'PM姓名',
        dataIndex: 'pmName',
        key: 'pmName',
        width: 120,
    }, {
        title: '领域leader工号',
        dataIndex: 'talCode',
        key: 'talCode',
        width: 100,
    }, {
        title: '领域leader姓名',
        dataIndex: 'talName',
        key: 'talName',
        width: 100,
    }, {
        title: 'PML工号',
        dataIndex: 'pmlCode',
        width: 120,
        key: 'pmlCode',
    }, {
        title: 'PML姓名',
        dataIndex: 'pmlName',
        width: 120,
        key: 'pmlName',
    }, {
        title: '计收入确认方式',
        dataIndex: 'contractTypeIdName',
        width: 120,
        key: 'contractTypeIdName',
    }, {
        title: '过账编辑',
        dataIndex: 'postingEdit',
        width: 120,
        key: 'postingEdit',
    }, {
        title: '类别码13',
        dataIndex: 'categoryCode13',
        width: 120,
        key: 'categoryCode13',
    }, {
        title: '当月服务费收入不含税/人民币',
        dataIndex: 'cnyCurrentMonthIncomeNoTax',
        width: 120,
        key: 'cnyCurrentMonthIncomeNoTax',
    }, {
        title: '当月项目确认FTE',
        dataIndex: 'currentMonthConfirmFte',
        width: 100,
        key: 'currentMonthConfirmFte',
    }, {
        title: '当月随机入组数（实际入组数）',
        dataIndex: 'currentMonthRandomAmount',
        width: 100,
        key: 'currentMonthRandomAmount',
    }, {
        title: '当月已确认标准访视数',
        dataIndex: 'currentMonthStandardVisitedAmount',
        width: 100,
        key: 'currentMonthStandardVisitedAmount',
    }, {
        title: '当月完成访视数',
        dataIndex: 'currentMonthVisitedAmount',
        width: 100,
        key: 'currentMonthVisitedAmount',
    }]

   getDataSource = () => {
        const { data } = this.state;

        let key = 0, idx = 1;
        const dataSource = [];
        if (data && data.length > 0) {
            data.map(item => {
                    dataSource.push({
                        key: key++,
                        num: idx++,
                        ...item,
                    });
            });
        }
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }
    render() {
        const { loading, pagination } = this.state;
        const dataSource = this.getDataSource();
        const{exportable}=this.props;
        return (
            <div>
                <Filter search={this.search} export={this.export} exportable={exportable}/>
                <TableC
                    loading={loading}
                    scrollY={460}
                    pagination={pagination}
                    columns={this.getColumns()}
                    data={dataSource}
                    onChange={this.handleTableChange}
                />
            </div>
        )
    }
}

export default RevenueVisit;



// WEBPACK FOOTER //
// ./src/components/homePage/revenueVisitAndContractPlan/RevenueVisit.js